export default __webpack_public_path__ + "static/media/logo.0b1654f0.png";